import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ImageSidebarItem from "./image-sidebar-item";
import {searchImages} from "../../common/services/image-data-service";

const ImageSidebar = ({setSelectedImage}) => {
    const [searchText, setSearchText] = useState('');
    const [imagesList, setImagesList] = useState([]);

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                const imagesListResult = await searchImages(searchText);
                setImagesList(imagesListResult);
            }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchText]);

    return (
        <>
            <div
                className="image-sidebar-container overflow-y-scroll h-full border border-gray-400 bg-gray-400 rounded pt-6 m-1 mt-4">
                <div className="flex flex-wrap justify-center">
                    {imagesList?.map((image, index) => (
                        <div key={index}>
                            <ImageSidebarItem imageDetail={image} setSelectedImage={setSelectedImage}/>
                        </div>
                    ))}
                </div>
            </div>

        </>
    )
}

export default ImageSidebar
